import { type DocumentType } from "@/gql/gql";

import type { GROUPS_QUERY } from "./graphql/groups-query";
import type { MEMBERS_QUERY } from "./graphql/members-query";

export type MembersListRow = NonNullable<
  DocumentType<typeof MEMBERS_QUERY>["organization"]
>["members"]["nodes"][0];

export type InvitationsListRow = NonNullable<
  DocumentType<typeof MEMBERS_QUERY>["organization"]
>["invitations"]["nodes"][0];

export type MembershipRequestsListRow = NonNullable<
  DocumentType<typeof MEMBERS_QUERY>["organization"]
>["membershipRequests"]["nodes"][0];

export type MemberMetadataFields = NonNullable<
  DocumentType<typeof MEMBERS_QUERY>["organization"]
>["memberMetadataFields"];

export type Group = NonNullable<
  DocumentType<typeof GROUPS_QUERY>["organization"]
>["groups"]["nodes"][0];

export const MEMBER_VIEWS = {
  ACTIVE: "active",
  DISABLED: "disabled",
  INVITATIONS: "invitations",
  REQUESTS: "membership-requests",
} as const;
